import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePostalCodeFields } from './hooks/usePostalCodeFields';
import styles from './PostalCodeFields.module.css';
import { Autocomplete } from '@mui/material';
import AuthField from '../AuthField/AuthField';

const PostalCodeFields = ({ data, setData, billing, zipHelper, zipError, cityHelper, cityError }) => {
  const { t } = useTranslation();
  const { calcAddress, calcPostalCode, calcAddressSuggestions, calcZipSuggestions, zips, settlements } =
    usePostalCodeFields();
  const zipField = billing ? 'billingZipCode' : 'contactZipCode';
  const cityField = billing ? 'billingCity' : 'contactCity';

  useEffect(() => {
    if (billing) {
      calcZipSuggestions(data?.billingCity, data?.billingZipCode);
      if (data?.billingZipCode?.length > 0) {
        const suggestion = calcAddress(data.billingZipCode);
        if (
          data?.billingCity &&
          settlements[Object.keys(settlements)?.find((key) => key === data?.billingCity)] == data?.billingZipCode
        ) {
          return;
        } else {
          setData({ ...data, billingCity: suggestion || '' });
        }
      } else if (data?.billingCity.length > 1 && Object.keys(settlements)?.find((key) => key === data?.billingCity)) {
        setData({ ...data, billingCity: '' });
      }
    } else {
      calcZipSuggestions(data?.contactCity, data?.contactZipCode);
      if (data?.contactZipCode?.length > 0) {
        const suggestion = calcAddress(data.contactZipCode);
        if (
          data?.contactCity &&
          settlements[Object.keys(settlements)?.find((key) => key === data?.contactCity)] == data?.contactZipCode
        ) {
          return;
        } else {
          setData({ ...data, contactCity: suggestion || '' });
        }
      } else if (data?.contactCity.length > 1 && Object.keys(settlements)?.find((key) => key === data?.contactCity)) {
        setData({ ...data, contactCity: '' });
      }
    }
  }, [data?.contactZipCode, data?.billingZipCode]);

  useEffect(() => {
    if (billing) {
      calcZipSuggestions(data?.billingCity, data?.billingZipCode);
      if (data?.billingCity?.length > 0) {
        const suggestion = calcPostalCode(data.billingCity, data.billingZipCode);
        setData({ ...data, billingZipCode: suggestion || '' });
      } else if (data?.billingZipCode.length > 1) {
        setData({ ...data, billingZipCode: '' });
      }
    } else {
      calcZipSuggestions(data?.contactCity, data?.contactZipCode);
      if (data?.contactCity?.length > 0) {
        const suggestion = calcPostalCode(data.contactCity, data.contactZipCode);
        setData({ ...data, contactZipCode: suggestion || '' });
      } else if (data?.contactZipCode?.length > 1) {
        setData({ ...data, contactZipCode: '' });
      }
    }
  }, [data?.contactCity, data?.billingCity]);

  return (
    <>
      <div className={styles.cell}>
        <Autocomplete
          id={zipField}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          ListboxProps={{ tabIndex: -1 }}
          options={zips}
          filterOptions={(options) => options}
          inputValue={data?.[zipField] || ''}
          onChange={(e, value) => setData({ ...data, [zipField]: value || '' })}
          onInputChange={(e, value, reason) => {
            if (reason === 'input') {
              setData({ ...data, [zipField]: value });
            }
          }}
          renderInput={(params) => (
            <AuthField
              ref={params.InputProps.ref}
              id={zipField}
              label={t('common.postalCode')}
              placeholder='0000'
              inputMode='numeric'
              inputProps={params.inputProps}
              error={zipHelper && zipError}
            />
          )}
        />
      </div>
      <div className={styles.cell}>
        <Autocomplete
          id={cityField}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          disablePortal
          ListboxProps={{ tabIndex: -1 }}
          options={calcAddressSuggestions(data?.[cityField] || '')}
          inputValue={data?.[cityField] || ''}
          onChange={(e, value) => setData({ ...data, [cityField]: value || '' })}
          onInputChange={(e, value, reason) => {
            if (reason === 'input') {
              setData({ ...data, [cityField]: value });
            }
          }}
          renderInput={(params) => (
            <AuthField
              ref={params.InputProps.ref}
              id={cityField}
              label={t('common.city')}
              inputProps={params.inputProps}
              error={cityHelper && cityError}
            />
          )}
        />
      </div>
    </>
  );
};

export default PostalCodeFields;
